<script>
import OrdersApi from "@/services/orders-api";
import BackOrdersApi from "@/services/backOrders-api";

import Swal from "sweetalert2";
import i18n from "../i18n";


/**
 * Orders-list component
 */
export default {
  props: {
    orderId: {
      type: Number,
      default: 0,
    },
    isCatalogList: {
      type: Boolean,
      default: false,
    },
    priority: {
      type: Number,
      default: null,
    },
    deliveryAddress: {
      type: String,
      default: null,
    },
    deliveryMode:{
      type: String,
      default: null,
    },
    promotionCode: {
      type: String,
      default: null,
    },
  },

  watch: {
      'orderId': function(){
        this.getOrder();
    },


  },

  data() {
    return {
        
      order: {lines:[], supplier:{city:{}, country:{}}, customer:{city:{}, country:{}},},
      
      //TODO to be replaced by constants !
      ORDER_STATUS_DRAFT: 0,
      ORDER_STATUS_SUBMITTED : 1,
      ORDER_STATUS_CONFIRMED : 2,
      ORDER_STATUS_DELIVERED : 3,

      previsionalDeliveryDate:null,

      role:null,

      availabilityDate:null,
      current_language: i18n.locale,


        
    };
  },  
  
    mounted() {
    this.getOrder();
    this.role=sessionStorage.getItem("userr");
  },

    methods: {

    getOrder() {

      OrdersApi.getOrder(this.orderId)
      .then(order => {
        this.order = order;
      })

      .finally(() => {
      })
    },

    priorityToLabel(priority) {
      switch(priority) {
        case 0: return 'low';
        case 1: return 'normal';
        case 2: return 'urgent';
        default: return 'normal';
      }
    },

    priorityToColor(priority) {
      switch(priority) {
        case 0: return 'secondary';
        case 1: return 'success';
        case 2: return 'danger';
        default: return 'success';
      }
    },

    statusToLabel(status) {
      switch(status) {
        case 0: return 'draft';
        case 1: return 'new';
        case 2: return 'confirmed';
        case 3: return 'delivered';
        case 4: return 'canceled';
        default: return '_';
      }
    },

    deliveryStatusToLabel(deliveryStatus,status){
      if(status!=2 && status!=3){
        return '_'
      }
          switch(deliveryStatus){
            case 0 : return 'notDelivered';
            case 1 : return 'partiallyDelivered';
            case 2 : return 'delivered';
            default: return 'notDelivered'
          }
    },

    deliveryStatusToColor(deliveryStatus,status){
      if(status!=2 && status!=3){
        return '_'
      }
      switch(deliveryStatus){
        case 0 : return 'danger';
        case 1 : return 'info';
        case 2 : return 'success';
        default: return 'danger'
      }
    },

    statusToColor(status) {
      switch(status) {
        case 0: return 'secondary';
        case 1: return 'danger';
        case 2: return 'info';
        case 3: return 'success';
        case 4: return 'secondary';
        default: return 'black';
      }
    },

    outstandingStatusToLabel(status){
      switch(status) {
        case 0: return 'OK';
        case 1: return 'Bloqué';
        case 2: return 'En cours';
        case 3: return 'Non Versée';
        case 4: return 'Sage.Exch';
        default: return '';
      }
    },

    billingStatusToLabel(status,orderStatus){
      if(orderStatus!=2 && orderStatus!=3){
        return '_'
      }
      switch(status){
        case 0: return 'notBilled';
        case 1:return 'partiallyBilled';
        case 2 :return 'billed';
        default: return '_'
      }
    },

    billingStatusToColor(status,orderStatus){
      if(orderStatus!=2 && orderStatus!=3){
        return '_'
      }
      switch(status){
        case 0: return 'danger';
        case 1:return 'warning';
        case 2 :return 'success';
        default: return '_'
      }
    },

    editConfirmedQuantity: function(line, index) {

      if (!this.order.isProcessable || this.order.status > 1) {
        return;
      }

      line.edit=true;
      let input = this.$refs['confirmedQuantityEdit-' + index][0];
      input.focus();
    },


    saveConfirmedQuantity(line) {
      
      if (line.confirmedQuantity == null) {
        line.confirmedQuantity = line.quantity
      }

      OrdersApi.saveConfirmedQuantity(line.id, line.confirmedQuantity)
        .then((order) => {
          if(order){
                line.edit=false;
                this.order = order;
                if(line.quantity != line.confirmedQuantity && line.confirmedQuantity != null){
                  this.availabilityDate=null
                }
          }
          })
    },

    confirm() {
      Swal.fire({
        title: i18n.t("order.alerts.confirm.title"),
        text: i18n.t("order.alerts.confirm.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t("order.alerts.confirm.confirmButtonText"),
        cancelButtonText:i18n.t("order.alerts.confirm.cancelButtonText")
      })
      
      .then(result => {
        if (result.value) {

          OrdersApi.confirmOrder(this.orderId)
            .then((order) => {

              if (order) {
                this.order = order;
              } 
            })
        }
      });
    },

    deliverOrder() {
      Swal.fire({
        title: i18n.t("order.alerts.deliver.title"),
        text: i18n.t("order.alerts.deliver.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t("order.alerts.deliver.confirmButtonText"),
        cancelButtonText: i18n.t("order.alerts.deliver.cancelButtonText")
      })
      
      .then(result => {
        if (result.value) {

          OrdersApi.deliverOrder(this.orderId)
            .then((order) => {
              if (order) {
                this.order = order;
              }
            })
        }
      });
    },


    cancelOrder() {
      Swal.fire({
        title: i18n.t("order.alerts.cancel.title"),
        html:  i18n.t("order.alerts.cancel.htmlNonBold") + "<strong class='text-danger'>" +i18n.t("order.alerts.cancel.htmlBold")+ "</strong>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t("order.alerts.cancel.confirmButtonText"),
        cancelButtonText: i18n.t("order.alerts.cancel.cancelButtonText"),
      })
      
      .then(result => {
        if (result.value) {

          OrdersApi.cancelOrder(this.orderId)
            .then((order) => {
              if (order) {
                this.order = order;
              }
            })
        }
      });
    },

    editBackOrder(line){
      BackOrdersApi.editBackOrder(line==null ? null : line.id)
      .then((order) => {
        if (order) {
          this.order = order;
        }
      })
    },

    exportEXCEL(orderId){
      OrdersApi.exportEXCEL(orderId)
    },

  },

}

</script>

<template>
  <div>
    <div v-if="!isCatalogList" class="row pr-4 pl-4 pt-4 d-print-none">
      <div class="col-xl-3 col-lg-3 col-md-3 col-4 text-left">
            <div class="form-group ">
              <label>{{$t("ordersMenu.list.header.orderStatus")}}</label>
              <h5 v-if="order && order.status!=null "><b-badge href="#" :variant="statusToColor(order.status)">{{order.extStatusStr != null ? order.extStatusStr : $t("ordersMenu.statusLabel."+statusToLabel(order.status))}}</b-badge></h5>
            </div>
      </div>
      <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-4 text-left">
            <div class="form-group ">
              <label>{{$t("ordersMenu.list.header.status")}}</label>
              <h5 v-if="order && order.status!=null "><b-badge href="#" :variant="deliveryStatusToColor(order.deliveryStatus,order.status)">{{$t("ordersMenu.statusLabel."+deliveryStatusToLabel(order.deliveryStatus,order.status))}}</b-badge></h5>
            </div>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-4">
            <div class="form-group text-right float-right">
              <label>{{$t("order.credit.label")}}</label><br>
              <h5 v-if="order"><b-badge href="#" :variant="billingStatusToColor(order.billingStatus,order.status)">{{$t("ordersMenu.billingStatus."+billingStatusToLabel(order.billingStatus,order.status))}}</b-badge></h5>
            </div>
      </div> -->
      <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-12 text-right pb-2">
        <div>
            <div class="form-group">
                <label class="text-right ">{{$t("order.previsionalDeliveryDate.label")}} </label><br>
                <span  class="text-info font-weight-bold font-size-16 pl-2 pb-0 mb-0">{{order.provisionalDeliveryDate ? order.provisionalDeliveryDate : '_'}}</span> 
            </div> <br>
          </div>
      </div> -->

    </div>

    <div class="row pr-4 pl-4">
      <div class="col-12">
        <div class="card border border-primary print-no-border">
          <div class="card-body">
            <div class="invoice-title">

              <div class="row">
                <div class="col-xs-12 col-sm-6 d-none d-lg-inline d-print-inline text-left">
                  <img :src="require('@/assets/images/logo-dark.png')" height="40" alt="logo" />
                </div>
                <div class="col-xs-12 col-sm-6 d-lg-none d-print-none text-left">
                  <img :src="require('@/assets/images/logo-dark.png')" height="40" alt="logo" />
                </div>

                <div class="col-xs-12 pt-4 pt-sm-0 col-sm-6 text-left text-sm-right">
                   <h4 class="text-primary font-size-16">{{$t("order.title")}} <strong>{{order.extId? order.extId  : "_" }}</strong> <br></h4>
                </div>
              </div>
              <!-- <hr/> -->


              <div class="row pt-2 d-none d-lg-flex d-print-flex">
                <div class="col-xs-12 col-sm-6 text-left">
                  <span class="font-size-14 font-weight-bold text-primary">Commerce de Pièces Auto en Gros </span><br/>
                  <!-- <span class="font-size-14 text-primary"></span><br/> -->
                </div>

                <!-- <div class="col-xs-12 col-sm-6 text-sm-right">
                    <address>
                    <strong>{{$t("order.header.client")}} :</strong> 
                    <br /><strong>{{this.order.customer.name}}</strong>
                    <br />{{this.order.customer.address}}
                    <span class="font-size-14">{{this.order.customerName}}</span>
                    <br/><br /><i v-if="order.customerPhone" class="fas fa-phone text-muted font-size-12"/> {{this.order.customerPhone}}
                  </address>
                </div> -->
              </div>

              <div class="row pt-0 pb-2 d-none d-lg-flex d-print-flex">
                <div class="col-xs-12 col-sm-6 text-left">
                  <span class="font-size-12 text-primary"><i>{{this.order.supplierFullAddress}}</i></span><br/>
                  <!-- <span class="font-size-12 text-primary">Web : www.sia-am.com </span><br/>
                  <span class="font-size-12 text-primary">E-Mail : commercial@sia-am.com </span> -->
                </div>

                
              </div>

             
              
            </div>

            
            
            <!-- <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <address>
                  <strong>{{$t("order.header.supplier")}}</strong> {{this.order.supplierName}}
                  <br />{{this.order.supplierFullAddress}}
                  <br />{{this.order.supplierShortAddress}}
                  <br/><br /><i v-if="order.supplierPhone" class="fas fa-phone text-muted font-size-12"/> {{this.order.supplierPhone}}
                  
                  <br />
                </address>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12  text-md-right">
                <address>
                  <strong>{{$t("order.header.client")}} :</strong> {{this.order.customerName}}
                  <br />{{this.order.customerShortAddress}}
                  <br/><br /><i v-if="order.customerPhone" class="fas fa-phone text-muted font-size-12"/> {{this.order.customerPhone}}
                </address>
              </div>
            </div> -->
            
            <div class="row pt-4">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <address>
                    <strong>{{$t("order.header.client")}}</strong> <br/>
                    <span class="font-size-14">{{this.order.customerName}}</span>
                  </address>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 text-md-right">
                <address>
                  <strong>{{$t("order.header.deiveryAddress")}}</strong>
                  <br /><span class="font-size-14">{{this.isCatalogList ? this.deliveryAddress : this.order.deliveryAddress}}</span>
                </address>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <address>
                  <strong v-if="order.submissionDate && order.submissionDate.length">{{$t("order.header.date")}}</strong>
                  <br /><span class="font-size-14">{{order.submissionDate}}</span>
                </address>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 text-md-right">
                <address>
                  <strong>{{$t("order.header.deliveryMode.label")}}</strong>
                  <br />        
                  {{this.isCatalogList ? this.deliveryMode : this.order.deliveryMode }}
                </address>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col-6 ">
                <address>
                  <strong>{{$t("order.header.date")}}</strong>
                  <br />{{order.submissionDate}}
                </address>
              </div>
              <div class="col-6 mt-3 text-right">
              </div>
            </div> -->
              <!-- <div class="p-2 mt-3">
                <h3 class="font-size-16">{{$t("order.orderLinesTable.title")}} </h3>
              </div> -->
            <div class="table-responsive mt-4">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 150px;">{{$t("order.orderLinesTable.ref")}}</th>
                    <th style="width: 300px;">{{$t("order.orderLinesTable.name")}}</th>
                    <th style="width: 250px;" class="text-right">{{$t("order.orderLinesTable.price")}}</th>
                    <th style="width: 120px;" class="text-right">{{$t("order.orderLinesTable.qte")}}</th>
                    <th style="width: 120px; background-color: rgb(191, 234, 255,0.5);" class="text-right">{{$t("order.orderLinesTable.confirmed")}}</th>
                    <th style="width: 120px;" class="text-right">{{$t("order.orderLinesTable.salesUnit")}}</th>
                    <th style="width: 200px;" class="text-right">{{$t("order.orderLinesTable.discount")}}</th>
                    <th style="width: 250px;" class="text-right">{{$t("order.orderLinesTable.priceHT")}}</th>
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="(line,i) in this.order.lines" :key="i">

                      <td>{{ line.ref }}</td> 
                      <td>{{ line.itemTitle }}</td> 
                     
                      <td class="text-right">{{ line.price }}</td>
                      <td class="text-right">{{ line.quantity }}</td>
                      <td class="text-right text-dark font-weight-bold font-size-16;"  style="background-color:rgb(191, 234, 255,0.5);">
                        <div v-if="!isCatalogList">
                          <div  :class="line.quantity != line.confirmedQuantity && line.confirmedQuantity != null ? 'text-danger' : ''"  >
                            {{ line.confirmedQuantity != null ? line.confirmedQuantity : line.quantity }} 

                                <i :class="line.quantity > line.confirmedQuantity && line.confirmedQuantity != null && (order.status == ORDER_STATUS_CONFIRMED || order.status == ORDER_STATUS_DELIVERED) && role==0 ? 
                                   line.backOrderId ? 'fas fa-bookmark font-size-16 ml-2' : 'far fa-bookmark font-size-16 ml-2'  : 
                                   'fas fa-bookmark font-size-16 ml-2 invisible'"  style="cursor:pointer" :title="line.backOrderId ?'Annuler le reliquat de commande' : 'Ajouter aux reliquats de commandes'" @click="editBackOrder(line)" ></i>
                          </div>

                        </div>

                        


                      </td>
                      <td class="text-right">{{line.itemSalesUnit}} </td>
                      <!-- <td style="background-color: #f6d39a#83bff4; border: 1px solid;"> -->
                       
                      <!-- <td class="text-right">{{ line.discountAmount }}</td> -->
                      <td class="text-right">{{ line.totalDiscountRate != '0' ? line.totalDiscountRate + '%' : '' }} </td>

                      <!-- TODO ce calcul doit etre faut du cote serveur ou avec le bon nombre de chiffres apres la virgule -->
                      <td class="text-right">{{ line.lineTotalAmount }}</td>

                    </tr>
              

                </tbody>
              </table>
            </div>

              <div class="row">
                 <div class="col-xl-10 col-lg-9 col-md-9 col-sm-12 col-xs-12 ">
                   <h5 class="m-0 float-right ">{{$t("order.orderTable.totalHT")}}</h5>
                 </div>
                 <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12  ">
                   <h5 class="m-0 float-right">{{this.order.totalBeforeDiscount}} </h5>
                 </div>
               </div>

              <div class="row pt-4">
                 <div class="col-xl-10 col-lg-9 col-md-9 col-sm-12 col-xs-12 ">
                    <span class="float-right">{{$t("order.orderTable.totalDiscount")}}</span>
                 </div>
                 <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12  ">
                   <span class="m-0 float-right">{{this.order.discountAmount}} </span>
                 </div>
               </div>

              <div class="row pt-4">
                 <div class="col-xl-10 col-lg-9 col-md-9 col-sm-12 col-xs-12 ">
                    <h5 class="m-0 float-right">{{$t("order.orderTable.totalNet")}}</h5>
                 </div>
                 <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12  ">
                   <h5 class="m-0 float-right">{{this.order.total}} </h5>
                 </div>
               </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isCatalogList" class="row p-4" >
      <!-- <div class="col-md-2 col-sm-6 p-1 text-left">
        <b-button variant="secondary" style="width: 100%" size="lg" @click="cancelOrder" :disabled="order.status != 1" v-if="order.isProcessable">
            <i class="fas fa-exclamation-triangle font-size-16 align-middle mr-2"></i> {{$t("order.buttons.cancel")}}
        </b-button>
      </div>
      <div class="col-md-2 col-sm-12 p-1 text-right">
        <b-button variant="warning" style="width: 100%" size="lg" @click="confirm" :disabled="order.status != 1" v-if="order.isProcessable">
                 <i class="fas fa-check-double font-weight-bold font-size-16 align-middle mr-2"></i> {{$t("order.buttons.confirm")}}
            </b-button>
      </div>
      <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" > 
        <b-button variant="success" style="width: 100%" size="lg" @click="deliverOrder" :disabled="order.status != 2" v-if="order.isProcessable" >
                <i class="fas fa-truck-loading font-weight-bold font-size-16 align-middle mr-2"></i>{{$t("order.buttons.deliver")}}
            </b-button>
      </div> -->
      <div class="col-md-10 col-sm-4 p-1 text-right d-print-none" >
        
      </div>
      <!-- <div class="col-md-2 col-sm-4 p-1 text-right d-print-none">
        <b-button variant="light" style="width: 100%" size="lg" @click.prevent="exportEXCEL(orderId)">
          <i class="fas fa-file-excel font-size-16 align-middle mr-2"></i> {{$t("order.buttons.export")}}  
        </b-button>
      </div> -->
      <div class="col-md-2 col-sm-4 p-1 text-right d-print-none text-right" > 
        <a href="javascript:window.print()">
            <b-button variant="warning" style="width: 100%" size="lg" >
              <i class="fa fa-print font-size-16 align-middle mr-2"></i> {{$t("order.buttons.print")}}   
            </b-button>
        </a>
      </div>

    </div>

    <div class="row mt-4 pr-2 pl-2">
      <div class="col-1"/>
      <div class="col-10">
        <hr v-if="!isCatalogList" class=" mb-4 mr-4 ml-4 d-print-none" />
      </div>
      <div class="col-1"/>
    </div>

    <div v-if="!isCatalogList" class="row pr-4 pl-4 mb-4 d-print-none">
      <!-- <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12 pr-lg-4 ">
        <div class="card  h-100">
          <div class="card-body">
            <h4 class="card-title mb-4 text-warning">{{$t("order.history.title")}} </h4>

            <div class="hori-timeline">
              <ul class="list-inline events">

          

                <li class="list-inline-item event-list">
                  <div class="mt-4">
                    <div class="px-3">
                      <p class="text-secondary font-weight-bold font-size-16 mb-4">{{order.date}}</p>
                    </div>

                    <div class="event-up-icon">
                      <i
                        class="bx bx-up-arrow-circle h1 text-secondary bx-fade-up-hover up-arrow-icon"
                      ></i>
                    </div>
                    <div class="event-date mt-3">
                      <h5 class="text-secondary"><i class="fab fa-firstdraft h2 text-secondary mr-2"></i>{{$t("order.history.timeline.draft")}}</h5>
                    </div>
                  </div>
                </li>


                <li class="list-inline-item event-list">
                  <div class="mt-4">
                    <div class="px-3">
                      <p class="text-primary font-weight-bold font-size-16 mb-4">{{order.submissionDate ? order.submissionDate : '-'}} <span v-if="order.submissionUserName" class="font-weight-normal font-size-14"><br> ({{order.submissionUserName}})</span></p>
                    </div>

                    <div class="event-up-icon">
                      <i
                        class="bx bx-up-arrow-circle h1 text-primary bx-fade-up-hover up-arrow-icon"
                      ></i>
                    </div>
                    <div class="event-date mt-3">
                      <h5 class="text-primary"><i class="bx bx-copy-alt h2 text-primary mr-2"></i>{{$t("order.history.timeline.new")}}</h5>
                    </div>
                  </div>
                </li>

            
                <li class="list-inline-item event-list">
                  <div class="mt-4">
                    <div class="px-3">
                      <p class="text-info font-weight-bold font-size-16 mb-4">{{order.confirmationDate ? order.confirmationDate : '-'}}</p>
                    </div>

                    <div class="event-up-icon">
                      <i
                        class="bx bx-up-arrow-circle h1 text-info bx-fade-up-hover up-arrow-icon"
                      ></i>
                    </div>
                    <div class="event-date mt-3">
                      <h5 class="text-info"><i class="bx bx-package h2 text-info mr-2"></i>{{$t("order.history.timeline.confirmed")}}</h5>
                    </div>
                  </div>
                </li>

      
                <li class="list-inline-item event-list">
                  <div class="mt-4">
                    <div class="px-3">
                      <p class="text-success font-weight-bold font-size-16 mb-4">{{order.deliveryDate ? order.deliveryDate : '-'}}</p>
                    </div>

                    <div class="event-up-icon">
                      <i
                        class="bx bx-up-arrow-circle h1 text-success bx-fade-up-hover up-arrow-icon"
                      ></i>
                    </div>
                    <div class="event-date mt-3">
                      <h5 class="text-success"><i class="bx bxs-truck h2 text-success  mr-2"></i>{{$t("order.history.timeline.delivered")}}</h5>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div> -->
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pt-4 pt-lg-0 ">
        <div class="card  h-100">
          <div class="card-body">
            <h4 class="card-title mb-4 text-warning">Notes de Commande</h4>
            <div class="media mb-4" v-if="order.message">
              <div class="mr-3">
                <img
                  class="media-object rounded-circle avatar-xs"
                  alt
                  src="@/assets/images/users/avatar-1.png"
                />
              </div>
              <div class="media-body" >
                <h5 class="font-size-13 mb-1">{{this.order.messageUserName}}</h5>
                <p class="text-muted mb-1">
                    {{this.order.message }} </p>
        
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>
<style >
.modal-dialog.modal-xl {
    min-width: 95% !important;
}

@media print {
  .print-no-border{
      border: 0;
      border-color: white !important;
  }
}

</style>
